"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyAdministratorDto = void 0;
class CompanyAdministratorDto {
}
exports.CompanyAdministratorDto = CompanyAdministratorDto;
//# sourceMappingURL=company-administrator.dto.js.map